var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "AppNavigationItem",
    { attrs: { title: _vm.sharee.displayName } },
    [
      _c(
        "template",
        { slot: "icon" },
        [
          _vm.sharee.isGroup
            ? _c("div", { staticClass: "avatar icon-group" })
            : _vm.sharee.isCircle
            ? _c("div", { staticClass: "avatar icon-circle" })
            : _c("Avatar", {
                attrs: {
                  user: _vm.sharee.id,
                  "display-name": _vm.sharee.displayName
                }
              })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "counter" },
        [
          _c(
            "ActionCheckbox",
            {
              attrs: {
                disabled: _vm.updatingSharee,
                checked: _vm.sharee.writeable
              },
              on: { "update:checked": _vm.updatePermission }
            },
            [
              _vm._v(
                "\n\t\t\t" + _vm._s(_vm.$t("calendar", "can edit")) + "\n\t\t"
              )
            ]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "template",
        { slot: "actions" },
        [
          _c(
            "ActionButton",
            {
              attrs: { icon: "icon-delete", disabled: _vm.updatingSharee },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  $event.stopPropagation()
                  return _vm.unshare($event)
                }
              }
            },
            [
              _vm._v(
                "\n\t\t\t" +
                  _vm._s(
                    _vm.$t("calendar", "Unshare with {displayName}", {
                      displayName: _vm.sharee.displayName
                    })
                  ) +
                  "\n\t\t"
              )
            ]
          )
        ],
        1
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }